"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Twitter, ArrowUp, MapPin, Phone, Mail, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage#" className="block">
              <img src="https://skilled-sunfish.10web.cloud/wp-content/uploads/2026/02/VOB_Veteran_Owned_Business_Logo_Full_Color_150-e1772066372538.png" alt="Call Green Haven Property Maintenance" className="object-contain !w-[100px] !h-[100px]" />
            </Link>
            <div className="space-y-4">
              <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
                Dedicated to transforming your property with expert craftsmanship and reliable service. Your satisfaction is our blueprint.
              </p>
              <div className="flex items-center gap-2 text-primary">
                <CircleCheck className="h-5 w-5" />
                <span className="font-medium text-sm tracking-wide">Quality Guaranteed</span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Quick Links</h3>
            <nav className="flex flex-col space-y-3">
              {[{
              label: "Home",
              href: "/"
            }, {
              label: "Services",
              href: "/services"
            }, {
              label: "Gallery",
              href: "/gallery"
            }, {
              label: "Request Estimate",
              href: "/contact"
            }].map((link, i) => <div key={i} data-index={i}>
                  <Link to={link.href} className="text-muted-foreground hover:text-foreground transition-colors duration-200 text-sm inline-flex items-center">
                    {link.label}
                  </Link>
                </div>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Contact Us</h3>
            <div className="flex flex-col space-y-4">
              <div className="flex items-start gap-3 text-muted-foreground group">
                <MapPin className="h-5 w-5 text-primary shrink-0 mt-0.5 group-hover:text-foreground transition-colors" />
                <span className="text-sm leading-relaxed">We Come To You</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground group">
                <Phone className="h-5 w-5 text-primary shrink-0 group-hover:text-foreground transition-colors" />
                <span className="text-sm">920.325.6665</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground group">
                <Mail className="h-5 w-5 text-primary shrink-0 group-hover:text-foreground transition-colors" />
                <span className="text-sm">GreenHavenProperty.Online@GMail.com</span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-6 lg:items-end">
            <h3 className="text-lg font-semibold tracking-tight text-foreground lg:text-right w-full">Connect</h3>
            <div className="flex gap-4">
              {[{
              icon: Facebook,
              href: "https://facebook.com"
            }, {
              icon: Instagram,
              href: "https://instagram.com"
            }, {
              icon: Twitter,
              href: "https://twitter.com"
            }, {
              icon: Linkedin,
              href: "https://linkedin.com"
            }].map((social, i) => <Link key={i} to={social.href} newTab className="bg-secondary/50 p-2.5 rounded-full text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300" aria-label="Social Media Link">
                  <div data-index={i}>
                    <social.icon className="h-5 w-5" />
                  </div>
                </Link>)}
            </div>
            
            <div className="pt-4">
              <Button variant="outline" size="sm" onClick={scrollToTop} className="gap-2 border-primary/30 hover:border-primary hover:bg-primary/10 text-muted-foreground hover:text-primary transition-all">
                Back to Top
                <ArrowUp className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>

        <Separator className="bg-primary/20 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground/60">
          <p>© 2026&nbsp;Green Haven Property Maintenance. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>;
}